import { FC } from "react";
import { Spinner } from "@cronika/ui";

export const CircularLoading: FC = () => (
  <div className="w-full h-full flex items-center justify-center">
    <Spinner color="warning" size="lg" />
  </div>
);
